// Layout.jsx
import { Outlet } from "react-router-dom";
import Navbar from "./shared/Navbar";
import Footer from "./Footer";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "./shared/AuthContext/AuthContext";
import { Dimmer, Loader } from "semantic-ui-react";

export default function Layout() {
  const [isLoading, setIsLoading] = useState(true);
  const isFirstRender = useRef(true);
  const { getAuthToken } = useAuth();

  const initializeComponent = async () => {
    const accessToken = await getAuthToken();
    if (accessToken) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      initializeComponent();
    }
  }, []);

  return (
    <div className="content-app">
      <div className="background">
        {isLoading ? (
          <Dimmer active inverted>
            <Loader inverted size="massive">
              Loading
            </Loader>
          </Dimmer>
        ) : (
          <>
            <Navbar />
            <Outlet />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
